import { useContext } from 'react'

import {
  Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useArtwork from '@hooks/useArtwork'
import useOrderItem from '@hooks/useOrderItem'

import ArtworkUpload from '@components/ArtworkUpload'

const MODAL_KEY = 'UploadArtworkModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const UploadArtworkModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { orderItem: initOrderItem } = modalPayload

  const artworkPayload = useArtwork({ id: initOrderItem.artwork_id })
  const { artwork: initArtwork } = artworkPayload

  const { callbacks: { manageOrderItem } } = useOrderItem(initOrderItem)

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Upload" titleSecondLine="Artwork" />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="*Upload Artwork">
            <ArtworkUpload
              artwork={initArtwork}
              callbacks={{
                closeModal,
                manageOrderItem,
              }}
            />
          </Form.Field>
        </Form>
      </SidebarModal.Content>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <UploadArtworkModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
